import styled from '@emotion/styled';

export const MessageWrapper = styled.div`
  padding: 15px 20px;
`;

export const MessageContainer = styled.div({
  paddingRight: 20,
  paddingLeft: 20,
});